import { useEffect, useRef } from "react"
import io from "socket.io-client"
import { useStore } from "../store"

const ActiveAptBroadcaster = () => {
  const socket = useRef()
  const url = process.env.REACT_APP_MARKETING_SUITE
  const role = process.env.REACT_APP_ROLE
  const activeApt = useStore(state => state.activeApt)
  const setActiveApt = useStore(state => state.setActiveApt)

  const fullScreenPlan = useStore(state => state.fullScreenPlan)
  const setFullScreenPlan = useStore(state => state.setFullScreenPlan)

  const state = { active: activeApt, fullScreenPlan: fullScreenPlan }

  useEffect(() => {
    socket.current = io(url)
    socket.current.emit("subscribe-actaptzustand", 1000)
    if (role === "recipient") {
      socket.current.on("actaptzustand", actAptZustand => {
        setActiveApt(actAptZustand.active)
        setFullScreenPlan(actAptZustand.fullScreenPlan)
      })
    }
    return () => socket.current.close()
  }, [state, role, url])

  useEffect(() => {
    if (role === "sender") {
      socket.current.emit("actaptzustand", state)
    }
  }, [state, role, url])

  return null
}

ActiveAptBroadcaster.propTypes = {}

export default ActiveAptBroadcaster
